export interface LatLng {
  lat: number;
  lng: number;
}

export const M_PER_DEG_LAT = 111320;

/** The same longitude within [-180, 180). */
export const wrapLng = (lng: number) => ((((lng + 180) % 360) + 360) % 360) - 180;

export const toRadians = (deg: number) => (deg * Math.PI) / 180;

/** Metres per degree of longitude at the given latitude (spherical approximation). */
export const metresPerDegLng = (lat: number) => M_PER_DEG_LAT * Math.cos(toRadians(lat));
